import {Col, Container, Modal, Row} from "react-bootstrap";
import {AppContext} from "../../lib/AppContext";
import React, {useContext} from "react";
import {handleDefaultValues} from "../common/Utils";
import {useForm} from 'react-hook-form';
import MDButton from "../../components/MDButton";
import MDInput from "../../components/MDInput";

export default function ManageReleaseItemModal({releaseItem, show, saving, handleClose, handleSave}) {

  const [context, setContext] = useContext(AppContext);

  const {register, handleSubmit, setValue, control} = useForm({
    values: handleDefaultValues(releaseItem)
  });

  return (
    <Modal onHide={handleClose} size={'lg'} show={show}>
      <form
        onSubmit={handleSubmit(handleSave)} id={'memberForm'}>
        <Modal.Header closeButton>
          <Modal.Title>{releaseItem?.guid ? 'Edit' : 'Add'} Release Item</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            <Col className={'col col-main'} xs={12}>
              <Container>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group">
                      <MDInput
                        variant="outlined" type="text"
                        {...register('title')}
                        placeholder="Enter Item Title"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="title"
                        label="Item Title"/>

                    </div>
                  </Col>
                </Row>
                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group mt-4">

                      <textarea
                                rows={5}
                                {...register('description')}
                                className="form-control" id="description"
                                placeholder="Enter Description" />
                    </div>
                  </Col>
                </Row>

                <Row>
                  <Col className={'col'} sm={12} xs={12}>
                    <div className="form-group mt-4">
                      <MDInput
                        variant="outlined" type="text"
                        {...register('releaseNoteUrl')}
                        placeholder="Enter URL"
                        autoComplete="off"
                        InputLabelProps={{shrink: true}}
                        className="form-control" id="releaseNoteUrl"
                        label="Release Note Url"/>
                    </div>
                  </Col>
                </Row>

                <Row className={'mt-2'}>
                  <Col className={'col'} sm={6} xs={12}>

                  </Col>
                </Row>
              </Container>
            </Col>
          </Row>

        </Modal.Body>
        <Modal.Footer>
          <MDButton type="submit" color="info" disabled={saving}>
            {saving ? 'Saving...' : 'Save'}
          </MDButton>
        </Modal.Footer>
      </form>
    </Modal>
  );
}